/**
 * Installable app: register the service worker (public/sw.js) in production
 * builds. It caches the app shell only — API calls are never cached — so the
 * portal opens fast, installs to the desktop / home screen, and shows an
 * offline page instead of a browser error when the network is gone.
 */
export function ocRegisterServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err: unknown) => {
      // Never block the portal on this — it works the same without it.
      console.warn("[oc-pwa] service worker registration failed", err);
    });
  });
}
